import { toastPromise } from '@/utils/toasts';
import { RiFileLine } from '@remixicon/react';
import { Button, Flex, Icon, Subtitle } from '@tremor/react';

interface Props {
  text: string;
  copyText: string;
}

export function CopyToClipboard({ copyText, text }: Props) {
  return (
    <Flex justifyContent="start" style={{ gap: '1rem' }}>
      <Subtitle>{text}</Subtitle>
      <Button
        aria-label="Copy to clipboard"
        onClick={async () => {
          toastPromise(
            navigator.clipboard.writeText(copyText),
            {
              success: { title: 'Success!', message: 'Copied workspace ID to clipboard' },
              error: {
                title: 'Error!',
                message: 'Failed to copy workspace ID to clipboard',
              },
            },
            { hideProgressBar: true, position: 'bottom-right', autoClose: 3000 },
          );
        }}
        style={{
          padding: 0,
          backgroundColor: '#fff',
          borderRadius: '50px',
          border: 'none',
        }}
      >
        <Icon style={{ color: 'black' }} icon={RiFileLine} />
      </Button>
    </Flex>
  );
}
